import React from "react";
import { Helmet } from "react-helmet-async";
import "./Courses.css";

function Courses() { 
    return(
        <div>
            <Helmet>
                <title>Courses & Immersions | Adya Yoga</title>
                <meta
                  name="description"
                  content="Meditation, Pranayama, Chakra wisdom, Yoga Nidra and Mantra Chanting courses to deepen your practice."
                />
                <link rel="canonical" href="https://yogaadya.com/courses" />
                <meta name="robots" content="index, follow" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Adya Yoga" />
                <meta property="og:title" content="Courses & Immersions | Adya Yoga" />
                <meta property="og:description" content="Explore meditation, pranayama, Yoga Nidra and mantra courses." />
                <meta property="og:url" content="https://yogaadya.com/courses" />
                <meta property="og:image" content="https://yogaadya.com/assets/images/Introduction.webp" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Courses & Immersions | Adya Yoga" />
                <meta name="twitter:description" content="Explore our transformative courses." />
                <meta name="twitter:image" content="https://yogaadya.com/assets/images/Introduction.webp" />
            </Helmet>
            <section className="py-md-3 py-sm-3 py-3" id="courses">
            <div className="events-retreats-container">                
                    {/* Header Section */}
                <div className="events-header">
                    <h1 className="events-title">Adya Yoga Courses & Immersions</h1>
                    <p className="events-subtitle">
                    Discover our range of transformative courses designed to enhance your spiritual journey
                    </p>
                </div>

                    <div className="row">
                        {/* Course 1 */}
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="course-item h-100">
                                <div className="course-content">
                                    <h4 className="course-title">Introduction to Meditation</h4>
                                    <div className="course-details">
                                        <h5>Course Content:</h5>
                                        <ul>
                                            <li>Concept and Understanding of Meditation</li>
                                            <li>How to Meditate</li>
                                            <li>Breathing of Meditation</li>
                                            <li>Mantras for Meditating</li>
                                            <li>Affirmation and Intention setting</li>
                                            <li>Silence and Observation</li>
                                            <li>Controlling the Thoughts</li>
                                            <li>Personalised Meditation selection for you</li>
                                        </ul>
                                        <p><strong>Duration:</strong> 4 hours (To be divided in 2 sessions)</p>
                                        <p><strong>Level:</strong> Beginner</p>
                                        <p><strong>Pre Requisites:</strong> No prior experience needed</p>
                                        <p><strong>Distance Learning Possibility:</strong> Yes</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Course 2 */}
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="course-item h-100">
                                <div className="course-content">
                                    <h4 className="course-title">Mastering your Thoughts</h4>
                                    <div className="course-details">
                                        <h5>Course Content:</h5>
                                        <ul>
                                            <li>Origin and Tracking of Thought Process</li>
                                            <li>Finding personal thought patterns</li>
                                            <li>Silencing the Mental Chatter</li>
                                            <li>Tools to Mastering your Thoughts</li>
                                            <li>Thoughts Control Quick Fix</li>
                                            <li>Creation of Daily Practice</li>
                                        </ul>
                                        <p><strong>Duration:</strong> 4 hours (To be divided in 2 sessions)</p>
                                        <p><strong>Level:</strong> All levels</p>
                                        <p><strong>Pre Requisites:</strong> No prior experience needed</p>
                                        <p><strong>Distance Learning Possibility:</strong> Yes</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Course 3 */}
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="course-item h-100">
                                <div className="course-content">
                                    <h4 className="course-title">Pranayama Basics</h4>
                                    <div className="course-details">
                                        <h5>Course Content:</h5>
                                        <ul>
                                            <li>Introduction to Pranayama and it's role in Yoga</li>
                                            <li>Understanding the importance of Breath and ways to Master it</li>
                                            <li>Breathing techniques to enhance energy level, reduce tension, help cure sinus, asthma, blood pressure, thyroid, pcod etc.</li>
                                            <li>Importance of Pranayama on Physical, Mental, Emotional, Social and Spiritual levels</li>
                                        </ul>
                                        <p><strong>Duration:</strong> 4 hours (To be divided in 2 sessions)</p>
                                        <p><strong>Level:</strong> Beginner</p>
                                        <p><strong>Pre Requisites:</strong> No prior experience needed</p>
                                        <p><strong>Distance Learning Possibility:</strong> Yes</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Course 4 */}
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="course-item h-100">
                                <div className="course-content">
                                    <h4 className="course-title">Chakras and the Wisdom behind</h4>
                                    <div className="course-details">
                                        <p className="course-intro">Frequently in a Yoga class, the Instructor keeps repeating these words, 'Feel your energy' OR 'Open your Anahata'. Sometimes we know what we are talking about but many times we don't. Whole purpose of any spiritual practice is to access your Energy field i.e, Aura and Chakras. The chakras are seven energy centres in your body that affect your physical, emotional, mental and spiritual well-being. Awareness about Chakras can be your gateway to a free, empowered, confident and balanced Life.</p>
                                        <h5>Course Content:</h5>
                                        <ul>
                                            <li>Understanding and basic knowledge about Aura</li>
                                            <li>What are Chakras. Simple ways to understand them</li>
                                            <li>Functions of Chakras</li>
                                            <li>The potential of our Energy system</li>
                                        </ul>
                                        <p><strong>Duration:</strong> 2 hours</p>
                                        <p><strong>Level:</strong> All levels</p>
                                        <p><strong>Pre Requisites:</strong> No prior experience needed</p>
                                        <p><strong>Distance Learning Possibility:</strong> Yes</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Course 5 */}
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="course-item h-100">
                                <div className="course-content">
                                    <h4 className="course-title">Yoga & 8 Limbs</h4>
                                    <div className="course-details">
                                        <h5>Course Content:</h5>
                                        <ul>
                                            <li>Overview of 8 Limbs of Yoga</li>
                                            <li>Discussing each limb step by step and their implication in Life</li>
                                            <li>Incorporating each limb into our practice</li>
                                            <li>Understanding Yamas and Niyamas and easy pathways to them</li>
                                            <li>Understanding of Asana & Dhyaana in detail</li>
                                            <li>Summary and Goal Setting</li>
                                        </ul>
                                        <p>This course is suitable for all Yoga practitioners who wish to go deeper in their study of Yoga and Yoga Teachers wishing to understand more about 8 limbs and incorporate into their teaching practice. Anyone who wishes to understand the Yogic philosophy and experience inner-peace can take up this course. It's a great help to strengthen your mind and have a joy-filled Life.</p>
                                        <p><strong>Duration:</strong> 10 hours (Sessions format to be decided based on discussion)</p>
                                        <p><strong>Level:</strong> All levels</p>
                                        <p><strong>Pre Requisites:</strong> No prior experience needed</p>
                                        <p><strong>Distance Learning Possibility:</strong> Yes</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Course 6 */}
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="course-item h-100">
                                <div className="course-content">
                                    <h4 className="course-title">Yoga Nidra Immersion</h4>
                                    <div className="course-details">
                                        <p className="course-intro">Yoga Nidra, the art of sleeping like Yogis. The deepest of all meditations, Yoga Nidra is performed in the most relaxed manner. Just by simply lying down, and relaxing you can work on deep levels of your consciousness. This technique has been practised by thousands of years by saints, yogis and enlightened souls. It's a practice that allows the body to relax deeply and yet have the mind alert.</p>
                                        <h5>Benefits of this Immersion Program:</h5>
                                        <ul>
                                            <li>Better levels of Physical, Mental and Emotional Health</li>
                                            <li>Great to reduce Stress, Anxiety and Depression</li>
                                            <li>Learn about yourself intimately</li>
                                            <li>Resolve past buried issues of your Life</li>
                                            <li>Improved levels of concentration, focus and memory</li>
                                        </ul>
                                        <p><strong>Duration:</strong> 5 Sessions</p>
                                        <p><strong>Level:</strong> All levels</p>
                                        <p><strong>Pre Requisites:</strong> No prior experience needed</p>
                                        <p><strong>Distance Learning Possibility:</strong> Yes</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Course 7 */}
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="course-item h-100">
                                <div className="course-content">
                                    <h4 className="course-title">Mantra Chanting- Daily Mantras</h4>
                                    <div className="course-details">
                                        <p className="course-intro">Mantra means a word or sound repeated to aid concentration in Meditation. Mantras are a beautiful instrument of Self- Transformation. Mantra chanting is a practice of Pranayama and Meditation being performed in one.</p>
                                        <h5>Course Content:</h5>
                                        <ul>
                                            <li>What are Mantras?</li>
                                            <li>Importance of Mantra Chanting</li>
                                            <li>The right way of Mantra Chanting. Posture, Timing, Breath and Intention</li>
                                            <li>Understanding of Japa Practice</li>
                                            <li>Use of Mala Beads for daily practice</li>
                                            <li>Creating a daily practice of Mantra Chanting</li>
                                        </ul>
                                        <p><strong>Duration:</strong> 6 Hours (to be divided in 5 Sessions)</p>
                                        <p><strong>Level:</strong> All levels</p>
                                        <p><strong>Pre Requisites:</strong> No prior experience needed</p>
                                        <p><strong>Distance Learning Possibility:</strong> Yes</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Course 8 */}
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="course-item h-100">
                                <div className="course-content">
                                    <h4 className="course-title">Mantra Chanting- Personalised Mantras</h4>
                                    <div className="course-details">
                                        <p className="course-intro">Mantra means a word or sound repeated to aid concentration in Meditation. Mantras are a beautiful instrument of Self- Transformation. Mantra chanting is a practice of Pranayama and Meditation being performed in one.</p>
                                        <h5>Course Content:</h5>
                                        <ul>
                                            <li>Choosing right Mantras for your need and intentions</li>
                                            <li>Mantra for Prosperity</li>
                                            <li>Mantra for Knowledge</li>
                                            <li>Mantra for Strength</li>
                                            <li>Mantra for Peace</li>
                                            <li>Seed Mantras</li>
                                        </ul>
                                        <p><strong>Duration:</strong> 4 Hours (to be divided in 3 Sessions)</p>
                                        <p><strong>Level:</strong> All levels</p>
                                        <p><strong>Pre Requisites:</strong> Mantra Chanting- Daily Mantras Course</p>
                                        <p><strong>Distance Learning Possibility:</strong> Yes</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Courses;